<template lang="pug">
  div.fill-height
    SubHeader
    v-container.fill-height(fluid='')
      v-row(align='center', justify='center')
        v-col(cols='12', md='8')
          v-card.my-10(v-for='event in events', :key='event.id')
            v-img(:src='event.img')
            v-card-title.secondary--text {{ event.title}}
            v-card-subtitle.primary--text {{ event.date }}
            v-card-text {{ event.description }}
            v-card-actions
              v-spacer
              v-btn(icon, color='primary')
                v-icon fas fa-calendar-alt
              v-btn(icon, color='secondary')
                v-icon fas fa-heart
      v-pagination.pag(v-model="current_page", :length='pages', :total-visible='total_visible', circle)
</template>

<script>
// @ is an alias to /src
import SubHeader from '@/components/SubHeader.vue'

export default {
  name: 'Family',
  components: {
    SubHeader,
  },
  data() {
    return {
      pages: 10,
      total_visible: 5,
      current_page: 1,
      events: [
        {
          id: 0,
          date: '2019-11-23',
          title: 'Titulo para colocar en fotos',
          img: 'http://micropetid.com/assets/images/bl.jpg',
          description: 'Información del evento o de lo que quieran decir que halla pasado ese día, la gente leera',
        },
        {
          id: 1,
          date: '2019-11-23',
          title: 'Titulo para colocar en fotos',
          img: 'http://micropetid.com/assets/images/bl1.jpg',
          description: 'Información del evento o de lo que quieran decir que halla pasado ese día, la gente leera',
        },
        {
          id: 2,
          date: '2019-11-23',
          title: 'Titulo para colocar en fotos',
          img: 'http://micropetid.com/assets/images/bl2.jpg',
          description: 'Información del evento o de lo que quieran decir que halla pasado ese día, la gente leera',
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
  .pag {
    margin-bottom: 5px;
  }
</style>
